const env = {
  REFERRAL_TENANT_ALIAS: String(process.env.REACT_APP_SAASQUATCH_TENANT_ALIAS),
  REFERRAL_API_URL: String(process.env.REACT_APP_SAASQUATCH_API_URL),
  BEAMER_PRODUCT_ID: String(process.env.REACT_APP_BEAMER_PRODUCT_ID),
  CUSTOMER_IO_SITE_ID: String(process.env.REACT_APP_CUSTOMER_IO_SITE_ID),
  APPCUES_ID: String(process.env.REACT_APP_APPCUES_ID),
  REFERRAL_WIDGET_TYPES: {
    clara: String(process.env.REACT_APP_SAASQUATCH_WIDGET_TYPE_CLARA),
    owner: String(process.env.REACT_APP_SAASQUATCH_WIDGET_TYPE_COMPANY_OWNER),
    general: String(process.env.REACT_APP_SAASQUATCH_WIDGET_TYPE_GENERAL),
  },
  QUALTRICS_PROJECT_ID: process.env.REACT_APP_QUALTRICS_PROJECT_ID,
  FEATURE_FLAG_CLIENT_SIDE_ID: String(
    process.env.REACT_APP_FEATURE_FLAG_CLIENT_SIDE_ID,
  ),
  FEATURE_FLAG_DEFAULT_CONTEXT: {
    key: process.env.REACT_APP_FEATURE_FLAG_CLIENT_USER_KEY,
    name: process.env.REACT_APP_FEATURE_FLAG_CLIENT_USER_NAME,
    email: process.env.REACT_APP_FEATURE_FLAG_CLIENT_USER_EMAIL,
  },
  ZENDESK_HOST: String(process.env.REACT_APP_ZENDESK_HOST),
  SENTRY_ENABLED: String(process.env.REACT_APP_SENTRY_ENABLED),
  REACT_APP_SENTRY_DSN_SHELL: String(process.env.REACT_APP_SENTRY_DSN),
}

export default env
